import { TimeOfDay } from '@dreryk/egabinet-waitlist-frontend-api';

export const TIMES_OF_DAY: TimeOfDay[] = ['MORNING', 'AFTERNOON', 'EVENING'];
